import { Navigate } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import AdminOrderInsight from "../pages/Alerts/OrderInsight";
import ClientOrderInsight from "../pages/ClientAlerts/ClientOrderInsight";
import { useStateValue } from "../context/StateValueContext";
import { hasPermission } from "../functions/permissionUtils";
import { PERMISSIONS } from "../constants/permissions";
import { useOrderInsightsAccess } from "../hooks/useOrderInsightsAccess";
import CompanySettingsUnavailable from "./common/CompanySettingsUnavailable";

// Gates /alerts/order-insight and picks admin vs client page.
// Admins (OI_ALL) skip the company flag. Clients wait for settings then
// redirect if Order Insights is off. Route <Protected> already requires
// OI_ALL or OI_OWN.
export default function OrderInsightRouteGuard() {
  const [{ user }] = useStateValue();
  const access = useOrderInsightsAccess();

  if (hasPermission(user, PERMISSIONS.OI_ALL)) {
    return <AdminOrderInsight />;
  }

  if (access === "loading") {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (access === "error") {
    return <CompanySettingsUnavailable />;
  }

  if (access === "hidden") {
    return <Navigate to="/dashboard" replace />;
  }

  return <ClientOrderInsight />;
}
